var styles = {
  "sizeS": "_sizeS_1ptdbnp_8",
  "sizeM": "_sizeM_1ptdbnp_11",
  "sizeL": "_sizeL_1ptdbnp_14",
  "dropdownMenu": "_dropdownMenu_1ptdbnp_18",
  "menu": "_menu_1ptdbnp_23"
};
export { styles as default };
